import { Bytes24, Bytes32 } from 'types/web3';

export function expandBytes24ToBytes32(b24: Bytes24): Bytes32 {
  return `0x${b24.slice(2)}0000000000000000`.toLowerCase();
}
